import { Logger, LoggerService } from "@Shared/logger";
import { DomainUtil } from "@Shared/utils";
import { HttpService } from "@Shared/http/http.service";
import { SETTINGS } from "@Config";
import { AppleEncryptedUuidResponse, AppleSubscriptionCheckResponse } from "../_models";

export class AppleRepository {
  private Logger: Logger = LoggerService.createLogger("AppleRepository");

  private static instance: AppleRepository;
  static get Instance(): AppleRepository {
    if (this.instance === null || this.instance === undefined) {
      this.instance = new AppleRepository();
    }
    return this.instance;
  }

  constructor() {
    this.Logger.trace("****  CTOR ****");
  }

  /**
   * GET {entitler}apple/subscription-check/{siteShortName}?access_token={encryptedUuid}
   * Returns true when the user's encrypted uuid maps to an active Apple News subscription.
   */
  public async checkSubStatus(encryptedUuid: string): Promise<boolean> {
    const siteShortName = DomainUtil.getRootDomain().split('.')[0];
    const endpoint = `apple/subscription-check/${siteShortName}?access_token=${encodeURIComponent(encryptedUuid)}`;
    try {
      const httpService = new HttpService(SETTINGS.entitler.baseUrl, 0);
      const data = await httpService.get<AppleSubscriptionCheckResponse>(endpoint);
      this.Logger.trace("checkSubStatus response", data);
      return data?.status === 'subscribed';
    } catch (error) {
      this.Logger.warn("checkSubStatus request failed", error);
      return false;
    }
  }

  /**
   * GET {entitler}auth0/users/{uuid}?domain={rootDomain}
   * Exchanges an Auth0 user id for the entitler's encrypted uuid (used as Apple News access token).
   */
  public async getEncryptedUuid(auth0UserId: string): Promise<string | null> {
    const rootDomain = DomainUtil.getRootDomain();
    const endpoint = `auth0/users/${encodeURIComponent(auth0UserId)}?domain=${encodeURIComponent(rootDomain)}`;
    try {
      const httpService = new HttpService(SETTINGS.entitler.baseUrl, 0);
      const data = await httpService.get<AppleEncryptedUuidResponse>(endpoint, undefined, SETTINGS.entitler.apiKey);
      this.Logger.trace("getEncryptedUuid response", data);
      return data?.encryptedUuid ?? null;
    } catch (error) {
      this.Logger.warn("getEncryptedUuid request failed", error);
      return null;
    }
  }
}
